import api from './client'
import { invalidateCache } from '../../utils/cache'

export const getComptes = (forceRefresh = false, requestConfig = {}) => {
  return api.get('/comptes', { useCache: !forceRefresh, ...requestConfig }).then((res) => res.data?.data ?? [])
}

export const createCompte = async (data) => {
  const response = await api.post('/comptes', data)
  invalidateCache('/comptes')
  invalidateCache('/api/comptes')
  invalidateCache('/stats')
  invalidateCache('/api/stats')
  invalidateCache('/operations')
  invalidateCache('/api/operations')
  window.dispatchEvent(new Event('comptesChanged'))
  window.dispatchEvent(new Event('operationChanged'))
  return response.data
}

export const updateCompte = async (id, data) => {
  const response = await api.put(`/comptes/${id}`, data)
  // Invalider toutes les variantes d'URL (baseURL peut donner /comptes ou /api/comptes)
  invalidateCache('/comptes')
  invalidateCache('/api/comptes')
  invalidateCache('/stats')
  invalidateCache('/api/stats')
  invalidateCache('/operations')
  invalidateCache('/api/operations')
  window.dispatchEvent(new Event('comptesChanged'))
  window.dispatchEvent(new Event('operationChanged'))
  return response.data
}

export const deleteCompte = async (id) => {
  await api.delete(`/comptes/${id}`)
  invalidateCache('/comptes')
  invalidateCache('/api/comptes')
  invalidateCache('/stats')
  invalidateCache('/api/stats')
  invalidateCache('/operations')
  invalidateCache('/api/operations')
  window.dispatchEvent(new Event('comptesChanged'))
  window.dispatchEvent(new Event('operationChanged'))
}
